<template>
  <div>
    <!-- MODAL PROJETO ATIVO -->
    <SGPModalComponent
      v-model="abrirModalProjeto"
      @input="$emit('update:abrirModalProjeto', $event)"
      tamanho="xl"
      titulo="Projeto"
      :mostrarFooter="false"
      v-if="abrirModalProjeto"
      @sgpModalFechar="fecharModalProjeto"
    >
      <!-- <DadosProjetoComponent 
        v-if="circuito.ctrl_projeto"
        :projeto="circuito.ctrl_projeto" 
        :modal="false" 
        :fichatecnica="true"
      /> -->
    </SGPModalComponent>

    <SGPModalComponent
      v-if="abrirModalAgendVisitaTecnica"
      tamanho="xl"
      titulo="Dados do Técnico"
      :mostrarFooter="false"
      @sgpModalFechar="$emit('fecharModalAgendVisitaTecnica')"
    >
      <VincularTecnicosComponent
        :pcoWorkflowId="dadosFichaTecnica?.pco_workflow_id"
        :ctrlTarefaId="dadosFichaTecnica?.ctrl_tarefa_id"
      />
    </SGPModalComponent>

    <!-- MODAIS COMENTADOS - Mantidos para referência futura -->
    
    <!-- <ModalPcoCirAnotacaoComponent
      v-model="abrirModalAnotacao"
      v-if="abrirModalAnotacao"
      :pcoCircuitoId="circuito.id"
      :ctrlBlocoId="tarefaSelecionada.ctrl_bloco_id"
    /> -->

    <!-- <ModalPcoCirAdocaoComponent
      v-model="abrirModalAdocao"
      v-if="abrirModalAdocao"
      :pcoCircuitoId="circuito.id"
    /> -->

    <!-- <TratativasSemTratamentoComponent
      @fecharModalAtualizacao="fecharModalSemTratamento"
      :pco_tarefa_id="pcoTarefaId"
      :pco_circuito="circuito"
      v-if="listaDeTratativasSemTratamento.length && abrirModalSemTratamento"
      @tratativaAtualizacaoPayloadEmit="forceComponentUpdate"
      @conteudoFormularioDinamicoEmit="conteudoFormulario"
    /> -->

    <!-- <ChecklistPreparacaoAtivacaoModal 
      v-if="abrirModalChecklistAgendamento"
      :circuito="circuito"
      @fecharModal="abrirModalChecklistAgendamento = false"
    /> -->

    <!-- <SGPModalComponent
      v-model="abrirModalMulta"
      tamanho="sm"
      titulo="Aviso de multa"
      :mostrarFooter="false"
      v-if="abrirModalMulta"
      @sgpModalFechar="abrirModalMulta = false"
    >
      <p>Veja abaixo os detalhes da multa:</p>
      <h5>Data Compromisso Cliente: {{ circuito.data_prometida | formataDataPrometida }}</h5>
      <h5>Observações: {{ circuito.obs_multa || '-' }}</h5>
    </SGPModalComponent> -->

    <!-- <SGPModalComponent
      v-model="abrirSolicitacaoMobilidade"
      tamanho="sm"
      titulo="Solicitação de mobilidade"
      :mostrarFooter="false"
      v-if="!abrirModalMulta && abrirSolicitacaoMobilidade"
      @sgpModalFechar="abrirSolicitacaoMobilidade = false"
    >
      <p><strong>Descrição:</strong><br> {{ circuito.desc_solicitacao_mob }}</p>
      <p><strong>Tarefa para envio:</strong><br> {{ circuito.tarefa_solicitacao_mob }}</p>
    </SGPModalComponent> -->

    <!-- <SGPModalComponent
      v-model="abrirModalClientesContatos"
      tamanho="xl"
      titulo="Contatos do cliente"
      :mostrarFooter="false"
      @sgpModalFechar="abrirModalClientesContatos = false"
      v-if="abrirModalClientesContatos"
    >
      <p>Utilize a busca abaixo para localizar os contatos do cliente desejado:</p>
      <CtrlStar21ClientesContatosPage
        is_modal
        :ctrlStar21ClienteId="circuito.ctrl_star21_cliente_id"
      />
    </SGPModalComponent> -->

    <!-- <SGPModalImagemComponent
      v-if="abrirModalImage"
      :titulo="dadosFichaTecnica.pco_tarefa.ctrl_tarefa.tarefa"
      @sgpModalFechar="fecharModal"
      :mostrarFooter="false"
      :url="dadosFichaTecnica.pco_tarefa.ctrl_tarefa.url_file_processo"
    /> -->

    <!-- <div>
      <SGPConfirmacaoDelecaoComponent
        v-if="abrirModalDesfazerBlocoInteiro"
        @sgpCancelarDelecaoEmit="cancelarDesfazerBloco()"
        @sgpConfirmarDelecaoEmit="confirmarDesfazerBloco()"
        titulo="Atenção:"
        subtitulo="Tem certeza que deseja desfazer o bloco inteiro?"
      />
    </div> -->

    <!-- <SGPModalComponent
      v-model="abrirModalOrdemServico"
      tamanho="xl"
      titulo="Ordem de Serviço"
      :mostrarFooter="false"
      @sgpModalFechar="abrirModalOrdemServico = false"
      v-if="abrirModalOrdemServico"
    >    
      <OrdemDeServicoPage :modosDePara="parametrosModos" />      
    </SGPModalComponent> -->

    <!-- <ModalWf1Component 
      v-if="abrirModalWf1"
      v-model="abrirModalWf1"
      :pcoCircuito="circuito"
    /> -->
    
    <!-- <SGPModalComponent
      v-model="abrirModalConsulta"
      tamanho="xl"
      titulo="Consultas"
      :mostrarFooter="false"
      @sgpModalFechar="abrirModalConsulta = false"
      v-if="abrirModalConsulta"
    >
      <SGPTabsMenuHorizontalComponent
        :itemsTabs="itemsTabs"
        :propsPage="propsPage"
      />   
    </SGPModalComponent> -->
  </div>
</template>

<script>
// import DadosProjetoComponent from '@/modules/sgp/projetos/components/DadosProjetoComponent';
import VincularTecnicosComponent from './VincularTecnicosComponent';
import moment from 'moment';

export default {
  name: 'FichaTecnicaModais',
  
  components: {
    VincularTecnicosComponent,
    // DadosProjetoComponent,
    // Componentes comentados mantidos para referência
    // ModalPcoCirAnotacaoComponent,
    // ModalPcoCirAdocaoComponent,
    // TratativasSemTratamentoComponent,
    // ChecklistPreparacaoAtivacaoModal,
    // CtrlStar21ClientesContatosPage,
    // OrdemDeServicoPage,
    // ModalWf1Component,
    // SGPTabsMenuHorizontalComponent
  },
  
  props: {
    abrirModalProjeto: {
      type: Boolean,
      default: false
    },
    circuito: {
      type: Object,
      required: true
    },
    dadosFichaTecnica: {
      type: Object,
      default: () => ({})
    },
    abrirModalAgendVisitaTecnica: {
      type: Boolean,
      default: false
    },
  },
  
  methods: {
    fecharModalProjeto() {
      this.$emit('update:abrirModalProjeto', false);
    }
  },
  
  filters: {
    formataDataPrometida(val) {
      return moment(val).format('DD/MM/YYYY');
    }
  }
}
</script>
